<template>
  <div class="no-data">
    <img class="no-data__img" src="@/assets/img/empty.svg" />
    <h3 v-if="title" class="no-data__title">{{ title }}</h3>
    <p v-if="description" class="no-data__description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.no-data {
  text-align: center;

  &__img {
    margin-bottom: 16px;
  }
  &__title {
    font-size: 18px;
    line-height: 36px;
  }
  &__description {
    color: #B9BEC4;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 0;
  }
}
</style>
